import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import sppos2 from '../../../Assets/Images/Training/Training Compendium/sppos2.jpg';

const Determinants_of_Successful_Public_Parks_and_Open_Spaces = () => {

    return (
        <div className="mt-5">

            <h4>Determinants of Successful Public Parks and Open Spaces (SPPOS)</h4>

            <div className="card mt-5">
                <img
                    src={sppos2}
                    className="card-img-top"
                    alt="Poster"
                />
            </div>

            <div className="mt-5">
                <p><strong>Aim:</strong> To investigate the critical key determinants responsible for the success of  public parks and open spaces (PPOS) and identify the assessment and evaluation  criteria to develop an implementable framework.</p>
                <p>This compendium, ‘Determinants of Successful Public Parks and Open Spaces  (SPPOS)’ explores the essential factors or key determinants that contribute to the  vitality, effectivity, usability, and positive impact of urban public parks and open  spaces (PPOS). Recognizing the crucial role of public parks and open spaces  (PPOS) in enhancing urban quality of life (QOL), environmental sustainability, and  social well-being, this resource identifies the successful key determinants that  distinguish successful public spaces from underperforming ones. The  compendium delves into the various thematic determinants of SPPOS,  categorizing them further into sub-thematic category for clarity and comprehensive  understanding. It also establishes robust assessment and evaluation criteria to  measure the success of PPOS objectively. These criteria cover aspects such as  accessibility, safety and security, recreational activities and programming, comfort  and image, sociability, ecological health, and management effectiveness, providing  a framework for analysing existing public parks and open spaces and planning  new and successful ones.</p>
            </div>

        </div>
    );
};

export default Determinants_of_Successful_Public_Parks_and_Open_Spaces;
